module.exports = __webpack_public_path__ + "static/media/undraw_ai-agent_pdkp.2c97e491.svg";